import { useState } from 'react'
import axios from '@fs/zion-axios'
import { format } from '@fs/zion-locale/date-fns'
import useErrorReporter from './useErrorReporter'
import useFetchData from './useFetchData'

const localizedDate = 'PP'

// https://beta.familysearch.org/service/help/permit/resource_HelpersEndpoints.html
const fetchHelpers = async () => {
  const { data } = await axios.get('/service/help/permit/helpers')
  const helpers = data ?? []
  return helpers.map(({ expirationDate, ...helper }) => ({
    ...helper,
    // should be safe format to parse with native Date (e.g. "2021-06-23T17:52:56Z", https://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15, https://caniuse.com/#feat=mdn-javascript_builtins_date_parse_iso_8601)
    expirationDate: format(new Date(expirationDate), localizedDate),
  }))
}

const fetchHelpeeRequest = async () => {
  const { data } = await axios.get('/service/help/permit/requests?role=HELPEE')
  return data ?? { totalCount: 0, requests: [] }
}

const removeHelper = (userId) => axios.delete(`/service/help/permit/helpers/${userId}`)
const removeFromQueue = (requestId) => axios.delete(`/service/help/permit/requests/${requestId}`)

export default function useHelpers() {
  const reportError = useErrorReporter()
  const { data: remoteRequest, loading: requestLoading } = useFetchData(fetchHelpeeRequest, {
    initialData: {},
  })
  const { data: remoteHelpers, loading: helpersLoading } = useFetchData(fetchHelpers, {
    initialData: [],
  })
  const [localHelpers, setLocalHelpers] = useState(null)
  const [localRequest, setLocalRequest] = useState(null)
  const helpers = localHelpers || remoteHelpers
  const helpeeRequest = localRequest || remoteRequest

  const handleRemoveHelper = (userId) => {
    const newHelpers = helpers.filter((helper) => userId !== helper.userId)
    setLocalHelpers(newHelpers)
    removeHelper(userId).catch((error) => {
      setLocalHelpers(localHelpers)
      reportError(error)
    })
  }
  const handleRemoveFromQueue = (requestId) => {
    setLocalRequest({ totalCount: 0, requests: [] })
    removeFromQueue(requestId).catch((error) => {
      setLocalRequest(remoteRequest)
      reportError(error)
    })
  }

  return {
    helpers,
    helpersLoading,
    helpeeRequest,
    requestLoading,
    handleRemoveFromQueue,
    handleRemoveHelper,
  }
}
